import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BoxArrowUpRight } from "react-bootstrap-icons";
import ptwLogo from "../../Assets/sponsers/ptw.png";
import elekta from "../../Assets/sponsers/elekta.png";
import varian from "../../Assets/sponsers/Varian.webp";
import accuray from "../../Assets/sponsers/Accuray.png";
import krs from "../../Assets/sponsers/krs.png";
import cq from "../../Assets/sponsers/CQ.png";
import pocl from "../../Assets/sponsers/pocl.png";
import brain from "../../Assets/sponsers/brain.jpeg";
import onco from "../../Assets/sponsers/onco.jpeg";
import ray from "../../Assets/sponsers/ray.jpeg";
import mec from "../../Assets/sponsers/mec.png";

const sponsorsData = [
  {
    id: 1,
    title: "PTW",
    description:
      "Pioneering patient safety in radiation therapy through innovative, high-precision dosimetry solutions.",
    cardImage: ptwLogo,
    link: "https://www.ptwdosimetry.com/en/",
    category: "Gold",
  },
  {
    id: 2,
    title: "VARIAN",
    description:
      "Varian is committed to ensuring our systems work seamlessly with compatible products as one connected ecosystem ensuring flexibility within clinical workflows.",
    cardImage: varian,
    link: "https://www.varian.com/",
    category: "Platinum",
  },
  {
    id: 3,
    title: "ELEKTA",
    description:
      "An Elekta linac is more than a machine—it's a treatment solution—and our gold standard radiation treatment planning and review software, comprehensive quality assurance tools and extensive service options will support you in getting the most out of your linac.",
    cardImage: elekta,
    link: "https://www.elekta.com/products/radiation-therapy/",
    category: "Platinum",
  },

  {
    id: 4,
    title: "ACCURAY",
    description:
      "Accuray is expanding radiation therapy: our products can deliver it accurately, precisely and effectively, from oncology to neuro-radiosurgery and beyond.",
    cardImage: accuray,
    link: "https://www.accuray.com/",
    category: "Platinum",
  },
  {
    id: 5,
    title: "KRS-IPL",
    description:
      "KRS-IPL is the One Stop Shop solution for all needs in the Next Generation versatile and modern mould room devices for the department of radiation oncology.",
    cardImage: krs,
    link: "https://www.krs-ipl.com/",
    category: "Silver",
  },
  {
    id: 6,
    title: "CQ MEDICAL",
    description:
      "From researchers and scientists to designers and developers, CQ Medical is at the forefront of cutting-edge, patient-centric medical technology designed to deliver the best possible outcomes.",
    cardImage: cq,
    link: "https://cqmedical.com/",
    category: "Silver",
  },
  {
    id: 7,
    title: "POCL MEDICAL SOLUTIONS",
    description:
      "POCL Medical Solutions was founded in 1982 as a Prosthetic and Orthotic Appliances company in Mumbai.Further expanding our area of operations POCL ventured in Radiotherapy and Diagnostic accessories industries.",
    cardImage: pocl,
    link: "https://poclindia.com/",
    category: "Silver",
  },
  {
    id: 8,
    title: "BRAINLAB",
    description:
      "Brainlab has been innovating for over a quarter century in the areas of surgery and radiation therapy, developing hardware and software technology to help healthcare providers, physicians and their patients fight cancer and other conditions of the brain and body.",
    cardImage: brain,
    link: "https://www.brainlab.com/",
    category: "Silver",
  },
  {
    id: 7,
    title: "RAYSEARCH LABORATORIES",
    description:
      "RaySearch Laboratories is advancing cancer treatment through pioneering software. Software has unlimited potential, and we believe it is the driving force for innovation in oncology. Medical science never stands still, and neither does RaySearch.",
    cardImage: ray,
    link: "https://www.raysearchlabs.com/",
    category: "Silver",
  },
  {
    id: 7,
    title: "ONCOTECH",
    description:
      "Increasing demand for medical equipments around the world creates a need for more workflow oriented, better integrated, and automated solutions for treatment planning and management.",
    cardImage: onco,
    link: "http://www.oncotechus.com/",
    category: "Silver",
  },
  {
    id: 7,
    title: "MEC",
    description:
      "Meditronix Corporation, parent company of Radimage Healthcare India Pvt. Ltd., has an experience and standing of four decades in India. Serving the nation for such long in a dedicated radiation monitoring field we have established ourselves as a leader. We have been a renowned name for representing best brands and providing service support for all these years.",
    cardImage: mec,
    link: "https://www.meditronixindia.com/",
    category: "Silver",
  },
];

const Sponcers = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Function to get animation delay based on position
  const getAnimationDelay = (index) => {
    const rowIndex = Math.floor(index / 3);
    const positionInRow = index % 3;
    return `${rowIndex * 0.3 + positionInRow * 0.1}s`;
  };

  const groupedSponsors = sponsorsData.reduce((acc, sponsor) => {
    const category = sponsor.category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(sponsor);
    return acc;
  }, {});

  const categoryOrder = ["Diamond", "Platinum", "Gold", "Silver"];

  return (
    <>
      <style jsx>{`
        .animate-header {
          opacity: 0;
          transform: translateX(-100px);
          transition: all 1s ease-out;
        }

        .animate-header.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .animate-card-left {
          opacity: 0;
          transform: translateX(-100px);
          transition: all 0.8s ease-out;
        }

        .animate-card-left.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .animate-card-right {
          opacity: 0;
          transform: translateX(0px);
          transition: all 0.8s ease-out;
        }

        .animate-card-right.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .animate-button {
          opacity: 0;
          transform: translateX(-50px);
          transition: all 0.8s ease-out;
        }

        .animate-button.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .card-hover-effect {
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .card-hover-effect:hover {
          transform: translateY(-12px) scale(1.03);
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.25);
        }

        .card-hover-effect:hover .image-overlay {
          opacity: 0.3;
        }

        .card-hover-effect:hover .bottom-bar {
          transform: scaleX(1) !important;
        }

        .card-hover-effect:hover .card-title {
          color: #1a202c;
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            135deg,
            rgba(59, 130, 246, 0.1),
            rgba(147, 51, 234, 0.1)
          );
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .card-title {
          transition: color 0.3s ease;
        }

        .animate-on-scroll {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s ease-out;
        }

        .animate-on-scroll.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .bottom-bar {
          position: relative;
          height: 5px;
          width: 100%;
          background: linear-gradient(90deg, #ff3131, #ff914d);
          overflow: hidden;
        }

        /* Sliding line on top */
        .bottom-bar::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          height: 100%;
          width: 100%;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.4),
            transparent
          ); /* shimmer line */
          animation: none;
          pointer-events: none;
        }

        /* Trigger animation only on hover */
        .card-hover-effect:hover .bottom-bar::before {
          animation: slide-bar 0.6s ease-out forwards;
        }

        @keyframes slide-bar {
          from {
            left: -100%;
          }
          to {
            left: 100%;
          }
        }
      `}</style>

      <div
        ref={sectionRef}
        className="container-fluid py-1"
        style={{
          minHeight: "100vh",
          marginTop: "100px",
        }}
      >
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div
              className={`col-12 text-center animate-header ${
                isVisible ? "visible" : ""
              }`}
              style={{
                transitionDelay: isVisible ? "0.2s" : "0s",
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateX(0)" : "translateX(-100px)",
              }}
            >
              <h1
                className="display-4 fw-bold mb-3"
                style={{
                  color: "#195F7D",
                }}
              >
                Our Sponsors
              </h1>
              <p className="lead text-muted">
                We are grateful for the support of our sponsors.
              </p>
            </div>
          </div>

          {categoryOrder.map((category, index) => (
            <div key={category} className="mb-5">
              <h2
                className={`fw-bold mb-4 animate-header ${
                  isVisible ? "visible" : ""
                }`}
                style={{
                  color: "#195F7D",
                  borderBottom: "2px solid #195F7D",
                  paddingBottom: "10px",
                  transitionDelay: isVisible ? `${index * 0.2}s` : "0s",
                }}
              >
                {category} Sponsors
              </h2>
              {groupedSponsors[category] &&
              groupedSponsors[category].length > 0 ? (
                <>
                  {(() => {
                    const cards = groupedSponsors[category];
                    const rows = [];
                    let i = 0;
                    let single = true;
                    while (i < cards.length) {
                      if (single) {
                        rows.push(
                          <div
                            className="row g-4 justify-content-center"
                            key={`row-${i}`}
                          >
                            <div
                              key={cards[i].id}
                              className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center"
                              style={{
                                opacity: isVisible ? 1 : 0,
                                transform: isVisible
                                  ? "translateX(0)"
                                  : "translateX(-100px)",
                                transition: "all 0.8s ease-out",
                                transitionDelay: isVisible
                                  ? getAnimationDelay(i)
                                  : "0s",
                              }}
                            >
                              <div
                                className="card border-0 position-relative overflow-hidden card-hover-effect"
                                style={{
                                  cursor: "pointer",
                                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                                  height: "400px",
                                  borderTopRightRadius: "30px",
                                  borderBottomLeftRadius: "30px",
                                }}
                              >
                                {/* Image Header */}
                                <div
                                  className="position-relative d-flex align-items-center justify-content-center"
                                  style={{
                                    height: "180px",
                                    overflow: "hidden",
                                    flexShrink: 0,
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  <img
                                    src={cards[i].cardImage}
                                    alt={cards[i].title}
                                    style={{
                                      maxWidth: "80%",
                                      maxHeight: "80%",
                                      objectFit: "contain",
                                      transition:
                                        "transform 0.4s ease, filter 0.3s ease",
                                    }}
                                  />
                                </div>
                                <div
                                  className="card-body p-4 d-flex flex-column"
                                  style={{ height: "calc(100% - 70px)" }}
                                >
                                  <h5
                                    className="card-title fw-bold mb-1"
                                    style={{
                                      color: "#2c3e50",
                                      fontSize: "1.3rem",
                                      lineHeight: "1.3",
                                      minHeight: "2.6rem",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {cards[i].title}
                                  </h5>
                                  <p
                                    className="card-text flex-grow-1"
                                    style={{
                                      color: "#64748b",
                                      fontSize: "0.95rem",
                                      lineHeight: "1.6",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 4,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {cards[i].description
                                      ?.replace(/\r\n\r\n/g, " ")
                                      .trim()}
                                  </p>
                                  <div className="mt-auto d-flex justify-content-end">
                                    <a
                                      href={cards[i].link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="d-flex align-items-center"
                                      style={{
                                        textDecoration: "none",
                                        color: "#195F7D",
                                      }}
                                    >
                                      <span className="me-2">
                                        Visit Website
                                      </span>
                                      <BoxArrowUpRight size={20} />
                                    </a>
                                  </div>
                                </div>
                                <div
                                  className="position-absolute bottom-0 start-0 w-100 bottom-bar"
                                  style={{
                                    height: "6px",
                                    background:
                                      "linear-gradient(90deg, #195F7D, #2582A1)",
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        );
                        i += 1;
                      } else {
                        rows.push(
                          <div
                            className="row g-4 justify-content-between"
                            key={`row-${i}`}
                          >
                            {cards.slice(i, i + 2).map((card, idx) => (
                              <div
                                key={card.id}
                                className="col-lg-4 col-md-6 col-sm-12"
                                style={{
                                  opacity: isVisible ? 1 : 0,
                                  transform: isVisible
                                    ? "translateX(0)"
                                    : "translateX(-100px)",
                                  transition: "all 0.8s ease-out",
                                  transitionDelay: isVisible
                                    ? getAnimationDelay(i + idx)
                                    : "0s",
                                }}
                              >
                                <div
                                  className="card border-0 position-relative overflow-hidden card-hover-effect"
                                  style={{
                                    cursor: "pointer",
                                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                                    height: "400px",
                                    borderTopRightRadius: "30px",
                                    borderBottomLeftRadius: "30px",
                                  }}
                                >
                                  {/* Image Header */}
                                  <div
                                    className="position-relative d-flex align-items-center justify-content-center"
                                    style={{
                                      height: "180px",
                                      overflow: "hidden",
                                      flexShrink: 0,
                                      backgroundColor: "#f8f9fa",
                                    }}
                                  >
                                    <img
                                      src={card.cardImage}
                                      alt={card.title}
                                      style={{
                                        maxWidth: "80%",
                                        maxHeight: "80%",
                                        objectFit: "contain",
                                        transition:
                                          "transform 0.4s ease, filter 0.3s ease",
                                      }}
                                    />
                                  </div>
                                  <div
                                    className="card-body p-4 d-flex flex-column"
                                    style={{ height: "calc(100% - 70px)" }}
                                  >
                                    <h5
                                      className="card-title fw-bold mb-1"
                                      style={{
                                        color: "#2c3e50",
                                        fontSize: "1.3rem",
                                        lineHeight: "1.3",
                                        minHeight: "2.6rem",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {card.title}
                                    </h5>
                                    <p
                                      className="card-text flex-grow-1"
                                      style={{
                                        color: "#64748b",
                                        fontSize: "0.95rem",
                                        lineHeight: "1.6",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 4,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {card.description
                                        ?.replace(/\r\n\r\n/g, " ")
                                        .trim()}
                                    </p>
                                    <div className="mt-auto d-flex justify-content-end">
                                      <a
                                        href={card.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="d-flex align-items-center"
                                        style={{
                                          textDecoration: "none",
                                          color: "#195F7D",
                                        }}
                                      >
                                        <span className="me-2">
                                          Visit Website
                                        </span>
                                        <BoxArrowUpRight size={20} />
                                      </a>
                                    </div>
                                  </div>
                                  <div
                                    className="position-absolute bottom-0 start-0 w-100 bottom-bar"
                                    style={{
                                      height: "6px",
                                      background:
                                        "linear-gradient(90deg, #195F7D, #2582A1)",
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                        i += 2;
                      }
                      single = !single;
                    }
                    return rows;
                  })()}
                </>
              ) : (
                <div
                  className="text-center p-5 rounded"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <p className="lead text-muted mb-0">Coming Soon</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sponcers;
